import ReactGA from 'react-ga';

export const GAeventSubmit = (category, action, label) => {
	ReactGA.event({
		category,
		action,
		label,
		value: 1,
	});
};
